import {SET_TITLE, RESET_TITLE, UPDATE_ACTION_TIME, RESET_SESSION, SESSION_EXPIRED} from '../actions/page';

export default (state = {}, action) => {
	switch (action.type) {
		case SET_TITLE:
			return {title: action.title};
		case RESET_TITLE:
			return Object.assign({}, state, {title: undefined});
		case UPDATE_ACTION_TIME:
			return Object.assign({}, state, {
				session: {
					lastActionTime: Date.now(),
					isExpired: false
				}
			});
		case RESET_SESSION:
			return Object.assign({}, state, {session: {}});
		case SESSION_EXPIRED:
			return Object.assign({}, state, {
				session: {
					lastActionTime: undefined,
					isExpired: true
				}
			});
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/client/redux/reducers/page.js